
const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

export async function fetchEstudiantesInscritos(params = {}) {
  // Usar el endpoint correcto para el reporte filtrado
  let url = `${API_BASE}/escolar/reportes/estudiantes-inscritos/`;
  const query = new URLSearchParams(params).toString();
  if (query) url += `?${query}`;

  const res = await fetch(url, {
    credentials: 'include',
  });
  if (!res.ok) throw new Error('Error al obtener inscripciones');
  return res.json();
}
